exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 899px) and (min-width: 500px), screen and (max-width: 499px) {\n  .learning-app .menu,\n  .learning-app-popup .menu {\n    padding: 16px;\n  }\n}\n", ""]);
